const SentenceAnnotations = function() {

    this.sentenceAnnotations = [
        // index 0 = average sentence length annotations
        // index 1 = internal vs external ratio annotations
        // index 2 = top noun annotations
        [
            "So for example, Mark's average sentence length was 6 words during the first episode and likewise for Jez. In fact this holds pretty much throughout except for episodes 4 and 5 where Mark's average drops to 5. So much for him being the more learned of the two.",
            "We see for the very first episode Mark nearly had a 50/50 split internal vs external but this tapered off during the series. In contrast Jez started with very few internal lines, but this increased as the series progressed.",
            "Cancer is mentioned a lot during episode 1 as an argument ensues over the doctor's name for Toni's sister. You can see which episode Johnson makes his grand first appearance and in the final episode we see a lot of soul searching going on as Jez contemplates his own existence after Uncle Ray passes away."
        ],
        [
            "So for example, Mark's average sentence length was 6 words during the first episode but only 5 for Jez.",
            "This is the series where Jez has the least amount of internal thoughts compared to other series. This is particularly evident in episodes 2, 4, 5 and 6.",
            "This is the series in which Nancy is introduced for the first time and we can see from Jez's words how much he talks about her. Daryl the racist is prominent in Mark's words from episode 2. This is the same episode where Jez is trying to do the track for Gog's film. Jeff appears at the top of Mark's words on two occasions as he begins to plot his way into breaking up his and Soph's relationship. Jeff also appears in Jez's top words from episode 5 as they form a brief friendship. Student is mentioned by Mark and Jez in episode 4 as they both venture off to Darty, Jez to play a gig (not like Bez) and Mark to stalk April from the shoe shop.",
        ],
        [
            "So for example, Mark's average sentence length was 8 words during the first episode and 7 for Jez. This series shows a big increase in average sentence lengths compared with the first two series. It even goes up to 9 words per sentence for Mark during the final episode as he grapples with the prospect of proposing to Soph.",
            "We see that Mark continues to have the more internal lines compared to Jez, although Jez has more this series than in series 2 despite the lack of internal thoughts in episode 2. This is probably because of his constant bickering with Super Hans over the name of the pub...",
            "This is the series where we meet Big Suze for the first time. You can see from Jez's top words how besotted he his with her. Mark also mentions her a lot in episode 4 when they spend time together. Mark's words in episode 1 reflect his mildly harrowing experience at the hands of the muggers. Merry is mentioned a lot by both in episode 2 as they prove no help at all with her spiralling mental state. Illness is a theme in episode 3 as Jez locks the sick man of Europe in his room so as not to dampen his mushroom party. There's a legal theme for Jez in episode 5 for obvious reasons and Mark frets about the hotel in the Quantocks in the final episode as this is where he pops the question to Soph, albeit inadvertently."
        ],
        [
            "So for example, Mark's average sentence length was 8 words during the first episode but only 6 for Jez. Mark also has a higher average for episodes 2 and 3 but for the rest of the series both characters are tied with an average of 7.",
            "As usual, Mark has the more internal lines than Jez although during episode 6, \"The Wedding\", they both have fewer internal lines. This is surprising as usually the more stressful the situation is, the more \"internal thoughts\" the characters have as they fret over the situation. Perhaps because Mark and Jez are together the whole time meant they were sounding off each other as opposed to internalising their neuroses.",
            "Jez has some strange words. We see \"Finger\" and \"Blair\" in episode 1 as Sophie's Mum tempts him with some \"Blair resignation jam\". Russell, episode 4, is Russell \"The Orgazoid\", one of the most brilliant techno pioneers of all time who Jez gives a \"hand\" to from time to time. \"Dog\", \"Turkey\" and \"Mummy\" in episode 5 reflect the horror that is Jez killing, attempting to dispose of, barbecuing and finally eating, a dog. The less said about \"Melon\" in episode 6 the better. Mark's words are a bit more conventional. We see him struggling with Project Zeus during episode 2, Johnson's unworkable plan where Marketing becomes an arm of Sales which Mark has to pitch to the JLB board. Episode 3 is where Mark joins a gym. \"Foz\" in episode 4 is the dickhead who used to bully Mark at school."
        ],
        [
            "So for example, Mark's average sentence length was 6 words during the first episode but only 5 for Jez. In fact Jez never has longer sentences than Mark throughout the series. The longest average is Mark's during episode 3, this could be due to him attempting to turn on the charm during his disastrous speed dating encounter.",
            "Again we see Mark having the more internal lines than Jez. Jez starts with very few but it does increase slightly as the series progresses. Mark actually has closer to a 50/50 split compared to previous series as he grapples with finding \"the one\", how to defeat Sophie in the post-jilting spin war, controlling Jeremy's finances, trying to ignore crystal skulls and contemplating becoming a father.",
            "\"Date\" is mentioned by both during episode 1 as they venture on a double date to get Mark back in the game. The presence of the word \"Police\" indicates how that went. We see Mark mention Dobby in episode 2 as this is the series we meet her for the first time. \"Elgar\" refers to the composer Edward Elgar. Not that Jez turns to classical music, he's simply broke and Elgar appears on the back of a £20 note. \"Gun\" is mentioned by both in episode 4 as they find Jez's great-aunt's revolver which they christen \"gunny\". Finally, \"Orgones\" in the final episode refers to Jez joining a cult which according to them are the \"invisible molecules of universal life energy which govern our moods and our actions\"."
        ],
        [
            "So for example, Mark's average sentence length was 8 words during the first episode and 7 for Jez. Episode 4 is one of the very few times Jez beats Mark. Probably because Jez has to improvise as he lies to Gail about seeing Elena behind her back.",
            "As per previous series, Mark has more internal lines than Jez. Jez has very few internal lines during the first episode, probably because he's too busy bemoaning the loss of employment at JLB after his half a day's service to anyone that will listen.",
            "We can see \"Baby\" mentioned a lot, by both characters, as the mystery over who the dad concludes. Episode 1 is where JLB closes which we can see is Mark's top word. \"Dobby\" is mentioned a lot by Mark as he tries to win her over. Jeremy mentions Elena and Gail a lot as his dirty love triangle develops. We can see Mark's history walk career move from episode 3 as he tries to avoid taking the loss-adjusters job and we can see a party theme from the words in episode 5.",
        ],
        [
            "So for example, Mark's average sentence length was 8 words during the first episode and 7 for Jez. Mark beats or equals Jez's average in each episode with 8 being the highest in both episodes 1 and 5 as he tries to converse with the hospital staff and his overbearing father.",
            "Mark edges the amount of internal lines compared to Jez, but Jez does have more than previous series (in fact this is one of the very few series which has episodes in which Jez has more lines than Mark, see episodes 3 and 4). Episode 4 reduces his ratio a lot but this is the same for Mark as well. I guess being stuck in the \"Nether Zone\" together limits the internal thoughts each had, taking out their frustration on each other instead.",
            "We can see Mark's top words are baby themed as this is the series his son is born. He also talks about Dobby a lot as the battle for leader of Dobby club with Gerrard heats up. \"Book\" is the top word of both characters in episode 3 as Jez tries to read a \"relatively short book\" to impress Zahra's book group which Mark ends up reading for him. \"Kenneth\" may seem an odd word, bonus points if you remember what that refers to, I'd rather not say. \"Ben\" dominates Jez's top words as he obsesses over getting rid of him to be with Zahra. \"Suit\" is mentioned a fair bit in episode 2 as he tries to get Super Hans' band to perform in Zoot suits as a deal breaker to sign them to Ben's label. The top words are rounded off with Christmas and \"Party\" type words as the series ends with Christmas dinner and a failure to party hard on New Year's Eve.",
        ],
        [
            "So for example, Mark's average sentence length was 7 words during the first episode and 6 for Jez. As in previous series, Mark always equals or beats Jez's average, he's particularly wordy in episode 2 which is appropriate considering he's launching his new book.",
            "Jez really competes with Mark in this series for internal lines. In the final episodes he's almost equal as he agonises over the decision to come clean about his love for Dobby. Episode 3 is surprising in that Mark nearly has a 50/50 split internal to external what with fretting over Dobby moving in and trying to avoid being hit by \"The Snitch\" during paintballing.",
            "We see \"Interview\", and \"Gerrard\" are popular for Mark in the first episode as he juggles attending an interview at Baths, Bathrooms and Fittings and delivering the eulogy at Gerrard's funeral. \"Book\" is the third most popular in the second episode as Mark takes the literary world by storm with the release of Business Secrets of the Pharaohs. Episode 3's words look odd at first glance until you remember this is the episode with the famous band name game. We can see \"Committee\" in episode 5 as Mark \"The Honourable Man\" launches a putsch to take over as chairman of the housing committee. Finally we see \"York\" in the final episode which refers to Dobby's impending move to New York. Jez's words are dominated by his career move into life coaching and in the later episodes we can see \"Dobby\" appearing as he falls in love with her and frets over whether to come clean to Mark.",
        ],
        [
            "So for example, Mark's average sentence length was 6 words during the first episode and 7 for Jez. In fact this is the only series where Jez has an equal or higher average than Mark. Maybe this is due to him grappling with the prospect of middle age whilst trying to maintain a love triangle.",
            "The final series is no different in that Mark has more internal lines than Jez. Jez's internal thoughts diminish quite a lot towards the end of the series. Maybe this marks the end of Jez's youth and he begins middle age and leaves his partying life behind.",
            "You'll notice \"Jerry\" mentioned by both characters during the first episode. This isn't a typo for Jeremy, it is Mark's new cultured flatmate who Jez tries to get kicked out. \"Joe\" is one of Jez's top words throughout the series as he begins a relationship with both him and his girlfriend Megan. \"Bank\" is mentioned by both at points in the series as Mark begins his new job and Jez becomes an accomplice in robbing it. \"Dobby\" reappears just for the second episode but Mark finally moves on to his old crush, April. There's just the small problem of her being married, see \"Angus\" in episode 4.",
        ],
    ];

    this.audioAnnotations = [
        {
            series: "1",
            index: 546,
            internal: true,
            audio: "sophie.mp3",
            annotation: "Let's zoom in on some memorable lines from the series. Here Mark takes the unorthodox historical approach to love:",
            line: "Yes, that's the way. Sophie's the one. Toni's Russia - vast, mysterious, unconquerable. Sophie's Poland - manageable, won't put up too much of a fight.",
        },
        {
            series: "1",
            index: 604,
            internal: false,
            audio: "voicemail.mp3",
            annotation: "The chart really accentuates the longer lines, be it a prolonged internal monolgue or external rant. Here is the excruciating message left by Mark on Sophie's voicemail:",
            line: "Uh, Sophie. If you heard that, please ignore it, I'm not a racist. Far from it. Anyway uh it's good to hear your voice. I know it's only a recording but you have got a bloody nice voice and... God, I just called up to say hi and then, then I go and spoil it all by saying something stupid like I like you. I mean, not that. But anyway I noticed that the paper in the photocopier is running a bit low so I know it's not really your job but uh well you know, so, uh see you tomorrow.",
        },
        {
            series: "1",
            index: 162,
            internal: false,
            audio: "tins.mp3",
            annotation: "Jez makes his thoughts on tinned food abundantly clear:",
            line: "You realize tinned food is just for crackheads and wars.",
        },
        {
            series: "1",
            index: 228,
            internal: true,
            audio: "drugs.mp3",
            annotation: "Jez struggles to recover from a drugs binge the night before. What was the bad thing?",
            line: "Oh, I feel like loam, a piece of loam. Jesus, what am I talking about? I wish Mark was here. No more drugs. I don't need drugs. I mean what great music was ever made on drugs? Bowie, obviously, The Floyd, The Prodge, Aphex - the list is endless really, but they could have done it twice as fast with half the mess if they just... Ahh, was that the bad thing?",
        },
        {
            series: "1",
            index: 236,
            internal: false,
            audio: "ira.mp3",
            annotation: "Here's Jez trying, and failing, to join in with a political debate between Mark and Johnson:",
            line: "What I mean is that they should be more honest. I mean, at least Tony Adams from the IRA, he's like \"Yeah, I shoot people. I like shooting people.\" You know, if they were more honest, then maybe people would vote and not switch straight over when the news comes on.",
        },
        {
            series: "1",
            index: 838,
            internal: true,
            audio: "gay.mp3",
            annotation: "Noticeable are the episodes with more shorter bars because of an extra long outlier. Here Mark performs an experiment to see if he really does fancy Johnson:",
            line: "Good old unfriendly Mr Patel. Never says a word... whether you're buying cornflakes, fabric softener, or gay porn. So here we go, watch without prejudice. I'm just testing the water. I'm a sexual scientist. So OK, I'm keeping in trim. This is fine. Typical evening in, Johnson's doing the spreadsheet. There's nothing to be afraid of. It was very popular with the Romans and they got a lot done. How's it going Johnson? Haha, so quick. Yeah, some good kissing. Maybe I'm just bi-curious? What if that actually was Johnson, would that make me hotter? What about if he had Sophie's face? Or Sophie's body with Johnson's face. Mum, dad, I'm bi-curious. Yeah right, the bum. Nothing wrong with the bum. Ah! That's a little too rich for me! I just don't know!",
        },
        {
            series: "1",
            index: 398,
            internal: false,
            audio: "enya.mp3",
            annotation: "Same goes for Jez in episode 6. This is because of his \"Enya\" speech during Uncle Ray's funeral:",
            line: "Look, what I'm trying to say is that, if I was dying, and I decided that even though I'd never particularly been into, say uh... Enya before, but that now I really, really was into Enya and that in fact I thought Enya was great, and that Enya died for our sins and I wanted an Enya-themed funeral with pictures of Enya and lots and lots of mentions of... Enya, then I think it would be a bit bloody rich for my sister to ban all mention of Enya from my funeral.",
        },
        {
            series: "2",
            index: 478,
            internal: true,
            audio: "kalashnikov.mp3",
            annotation: "Let's zoom in on some of the more memorable lines from the series. Here Mark wonders if he's the type of person to go on a mass shooting spree:",
            line: "Yeah, you won't be so cocky, Jeff, when I come into the office with a Kalashnikov and two hundred rounds of ammunition. I'm probably exactly the sort of person who could end up doing something like that.",
        },
        {
            series: "2",
            index: 511,
            internal: true,
            audio: "freak.mp3",
            annotation: "Here's where Mark tries to let it all out at Rainbow Rhythms:",
            line: "Yeah, sure, honey. Appear to be opening the box while in fact, the lid stays very firmly on. She's buying it! God, it's so easy being a freak, no wonder they're ten a penny. I should get extra marks for not feeling a fucking thing.",
        },
        {
            series: "2",
            index: 150,
            internal: false,
            audio: "democracy.mp3",
            annotation: "Jez tries to convince Mark to let Daryl the racist play music for his upcoming video:",
            line: "It is kind of the same. I mean, aren't we supposed to be living in a multicultural democracy? And isn't that the point? You know, the Jews and the Muslims and the racists all living happily together, side by side, doing and saying whatever the hell they like?",
        },
        {
            series: "2",
            index: 654,
            internal: false,
            audio: "daryl.mp3",
            annotation: "Mark educates Daryl the racist about political correctness:",
            line: "No! I hate political correctness gone mad more than anyone! I don't want to teach the world to sing, that would be horrible, but slavery? The Holocaust? That's just not on! Whereas, \"I Have A Dream\", South Africa, Benetton, it's- you've got to say, fair enough. Yeah?",
        },
        {
            series: "2",
            index: 314,
            internal: false,
            audio: "revels.mp3",
            annotation: "Jez blows the lid on Mark's lie about being a mature student:",
            line: "He's not a mature student. He's been a loan manager for the last five years. He lives with me and he eats ready meals, and we play \"Guess the Revels\" and we watch Men In Black in front of our massive telly and we have a fucking good time.",
        },
        {
            series: "2",
            index: 883,
            internal: true,
            audio: "doomed.mp3",
            annotation: "Mark tries to get to grips with lad culture to try and fit in with Jeff as part of his plan to win Sophie back:",
            line: "OK, going undercover. Jeff's apparent mate, who couldn't possibly be trying to nick his bird from right under his stupid old fashioned nose. Mmm, OK, man-chat topics. Footballer Darren Anderton, figure of ridicule due to repeated injuries. Turkish shepherd, ate his own testicles. NB, ignore tragic earthquake context. Ferrari Testarossa, fast car. Obviously, no need to note that. Shit, I'm making too many notes! Just imbibe the culture. Um, yes. Civilisation is definitely doomed.",
        },
        {
            series: "2",
            index: 351,
            internal: false,
            audio: "geezer.mp3",
            annotation: "Unlike Mark's attempt to imbibe lad culture, Jez has no such problems, in fact, he's probably been spending too much time with Jeff:",
            line: "So, I was gonna twat this geezer. Then it turns out they're both Polish!",
        },
        {
            series: "2",
            index: 980,
            internal: true,
            audio: "condoms.mp3",
            annotation: "After Mark's plan to spend more time with Sophie fails he ends up in the ridiculous situation of having to buy condoms for Jeff:",
            line: "This is it. This is my lowest ever. Wish I told him to fuck off. Except then, I'd never be allowed back. OK, right. Fetherlite. Don't want him to enjoy it any more than is strictly necessary. Ultra Strong. Yeah, he won't feel a thing. But then, maybe he'll last longer and- oh Jesus! This is a minefield! Serve him right if I prick them all with pins and then... Sophie got pregnant, and therefore, he ended up getting married? Got to think through these plans more! I'll just go for these. Coloured. Least that'll make him look faintly ridiculous. Heh, I win! In the most minor way possible.",
        },
        {
            series: "2",
            index: 1073,
            internal: false,
            audio: "speech.mp3",
            annotation: "Mark's speech at Jez and Nancy's impromptu visa wedding:",
            line: "So, ladies and gentlemen. You'll forgive me, I haven't prepared a proper speech, but then perhaps that's appropriate, since this isn't a proper wedding. Or so the cynics may say. But I say to those cynics, listen, cynics, this is the modern world, and just because it's new and strange and unnerving doesn't mean it's not brilliant. In Ancient Rome, they had Cupid. In modern days, it's the Home Office. Love is blind. That's not a joke about David Blunkett. No, seriously, I would never make that joke.",
        },
        {
            series: "3",
            index: 1044,
            internal: false,
            audio: "systems.mp3",
            annotation: "Mark puts the slackers in their place in one of the best political lines in comedy history outside of The Thick of It:",
            line: "Listen, while we're at it, there are systems for a reason in this world. Economic stability, interest rates, growth. It's not all a conspiracy to keep you in little boxes. All right? It's only the miracle of consumer capitalism that means you're not lying in your own shit, dying at forty-three with rotten teeth, and a little pill with a chicken on it is not going to change that. Now come on. Fuck off!",
        },
        {
            series: "3",
            index: 364,
            internal: false,
            audio: "frosties.mp3",
            annotation: "Jez opines that Frosties are an acceptable breakfast cereal despite Mark's statement to the contrary:",
            line: "Oh right. What should I be having? Gentleman's relish with olives? Anyway, Crunchy Nut Corn Flakes are just Frosties for wankers.",
        },
        {
            series: "3",
            index: 942,
            internal: false,
            audio: "reality.mp3",
            annotation: "But Mark has the final word on the matter:",
            line: "Yeah well, Frosties are just Corn Flakes for people who can't face reality.",
        },
        {
            series: "3",
            index: 867,
            internal: true,
            audio: "porn.mp3",
            annotation: "Mark nearly gets caught by Big Suze researching nudey ladies on the internet:",
            line: "This is fine, there's nothing to be embarrassed about nowadays, looking at porn's just like lying to Parliament. It used to be wrong but now it's just a great big funny joke.",
        },
        {
            series: "3",
            index: 444,
            internal: false,
            audio: "jury.mp3",
            annotation: "Jez auditions for the modern remake of 12 Angry Men:",
            line: "OK, sure. If you want. Say it's a mistrial, go crying to Daddy. But look, maybe I didn't play by the rules this time. Maybe I am a bit of a maverick, but I think I've got this case pretty much solved. And, yes, I can apologise for how I've done that, but I could never apologise for telling the truth. And the truth is that this woman is evil! And if we let her go today, we are going to be responsible for whatever she does, so help me God, and let the Lord be my witness!",
        },
        {
            series: "3",
            index: 895,
            internal: true,
            audio: "jogger.mp3",
            annotation: "Mark finds jogging is the sport for him only to realise actually, it isn't, all within 10 or 11 seconds:",
            line: "Oh yeah, I'm ready. Ready to watch your lovely bottom before I have a heart attack. Hey, wow, I'm actually good at this. Maybe I'm a natural. Yeah, I'm a jogger. Of course, there had to be a sport for me. I just never realised. I'm a natural jogger. Feel the legs like two great steam locomotives pumping away. I'm Cram, I'm Ovett, I'm unstoppable. I'm- Jesus, is that a stitch? I- fuck, I think I'm gonna be sick. I've gotta... slow. I need to... walk. Oh, I think I'm gonna puke. I'm literally gonna die. What an idiotic boob I was about ten or eleven seconds ago.",
        },
        {
            series: "3",
            index: 828,
            internal: true,
            audio: "crapped.mp3",
            annotation: "A feverish Mark, after being locked in his room by Jez to prevent him spoiling his mushroom party, contemplates doing his business in a takeaway bag:",
            line: "Oh, God. Can I do this? If I do this, even if I end up marrying Sophie and we live in a detached house in Surrey, and buy a holiday home in Umbria, our children will always look up at the face of a man who once crapped in a takeaway bag. Plus, I'd have to hide it here somewhere in my room next to one of my... things. I could throw it out the window. No, that's what they want you to do. That's where society's headed! People shitting in bags and throwing them out the window at each other. Well, I'm not going to be the first! Not in my name!",
        },
        {
            series: "3",
            index: 777,
            internal: true,
            audio: "carpenter.mp3",
            annotation: "Mark proves that he knows nothing at all about the working class:",
            line: "What the hell is he laughing with the carpenter about? You have to maintain the barrier, or they'll re-tune your radio to a commercial station, and force you to borrow their pornography.",
        },
        {
            series: "4",
            index: 628,
            internal: false,
            audio: "tyrants.mp3",
            annotation: "Let's look at some of the more memorable lines from the series. Here Mark tries to quash his doubts about the wedding even after Sophie tries to buy him a Chairman Mao t-shirt:",
            line: "Look, I know I might have mentioned some doubts, but that was pub talk. You can't bring up pub talk in the cold light of day. You know how I get after the pub, like when I ordered the Abdominizer. Besides, she's good for me, Jez, she's dragging me into the 21st century, with its meaningless logos and ironic veneration of tyrants. It's all good, my friend. It's all good.",
        },
        {
            series: "4",
            index: 680,
            internal: false,
            audio: "diana.mp3",
            annotation: "But he ultimately fails and the doubts turn to a sort of resignation towards a loveless marriage:",
            line: "I don't know, maybe. I mean, she's so nice. So what if I don't really love her. Charles didn't really love Diana and they were all right. Sort of.",
        },
        {
            series: "4",
            index: 806,
            internal: false,
            audio: "prick.mp3",
            annotation: "Mark's Project Zeus all-nighter with Gerrard fails to materialise anything of substance:",
            line: "Yes, of course. OK, so, final analysis. What have we actually got, what am I gonna present to the board? Not that, that sounded good at 3am when we were high on Diet Coke. That's bullshit. That's just table talk, that's not fit for public consumption. This... is that it? Where's the actual sustenance, where's the beef? Gerrard, we've got... there's... nothing. I've got nothing, I've got fucking nothing here. We haven't got anything. We've spent all night doing nothing, Gerrard, you prick!",
        },
        {
            series: "4",
            index: 215,
            internal: false,
            audio: "sandwiches.mp3",
            annotation: "Jez has his first brush with the real world:",
            line: "You know, I'm the first white English person on the cleaning staff. I'm getting a whole new view of life, the other side of the potato. They have these sandwiches, but they don't come from shops, they make them themselves.",
        },
        {
            series: "4",
            index: 302,
            internal: false,
            audio: "playstation.mp3",
            annotation: "Jez proves his lack of understanding of how the modern economy functions:",
            line: "Oh yeah, that's really gonna break his balls if I roll in an hour late. Mark, this is Russell Orgazoid. He's a creative, I'm a creative. We don't make steam engines out of pig iron in this country any more, yeah? We hang out, we fuck around on the PlayStation, we have some Ben and Jerry's. That's how everyone makes their money now, yeah?",
        },
        {
            series: "4",
            index: 1028,
            internal: true,
            audio: "lions.mp3",
            annotation: "At the safari park Jez throws Mark to the lions:",
            line: "Christ, what do you do to avoid lion attack? Soil yourself? Or is that grizzly bears? Hate to shit myself for no reason and get eaten. The final humiliation.",
        },
        {
            series: "4",
            index: 1133,
            internal: false,
            audio: "bishop.mp3",
            annotation: "Mark prefers an evening of culture rather than Jez's debauchery:",
            line: "I don't want sweet punani action. I wanna take your bishop and grind you down.",
        },
        {
            series: "4",
            index: 434,
            internal: true,
            audio: "dog.mp3",
            annotation: "Jez does his bit for Greenpeace, but not, sadly, for the RSPCA:",
            line: "Oh yeah, pissed and stoned in a gas-guzzler. This is the life. Already given a quid to Greenpeace this year, so I'm golden. Not the dog, not the dog. Shit, the dog!",
        },
        {
            series: "4",
            index: 458,
            internal: false,
            audio: "laid.mp3",
            annotation: "Jez really needs to get his priorities straight:",
            line: "Mark, if I can just get rid of the dog corpse, there's a chance I still might get laid, here.",
        },
        {
            series: "4",
            index: 1213,
            internal: false,
            audio: "hole.mp3",
            annotation: "Mark, quite rightly, refuses to get involved:",
            line: "Jeremy, there are many things I would do to help you, but digging a hole in the wintry earth with my bare hands so that you can bury the corpse of a dog you killed, is not one of them.",
        },
        {
            series: "4",
            index: 1227,
            internal: true,
            audio: "wedding.mp3",
            annotation: "Mark gets the wedding jitters and a comatose Super Hans in his hallway doesn't help:",
            line: "OK, here we go, wedding day. I am heading for a wedding. How do I feel? Empty? Check. Scared? Check. Alone? Check. Just another ordinary day. Ha ha. Very funny. Oh, great, I didn't expect a freshly ironed shirt, but him?",
        },
        {
            series: "4",
            index: 1274,
            internal: true,
            audio: "kidney.mp3",
            annotation: "Mark resorts to physical harm to try and get out of the marriage:",
            line: "God, what's happening to me? Am I really gonna get married? Don't want to, but calling off the wedding at the last minute? Don't want to hurt lovely Sophie. Need time to think. How can I buy some time? Contract TB? But where from? No badgers. Try to get beaten up? I could say, he's got a fat head. Call him a jizz-cock? Not actually an insult, all cocks are jizz-cocks really. Be like calling him a piss-kidney. Road traffic accident? Yeah, that'd kick everything into touch for a few months. Shit, could I? Here it comes. Come on, Mark, take the hit. Keep your eyes on the prize.",
        },
        {
            series: "4",
            index: 592,
            internal: false,
            audio: "piss.mp3",
            annotation: "Finally, no analysis of this series would be complete without Jez's failure to reach a toilet:",
            line: "Yes, I'm doing it already. I'm so pathetic that as soon as you ordered me to piss myself, I started the procedure. This is what you've done. You've ground down my sense of self-worth over the years. I hope you're proud.",
        },
        {
            series: "5",
            index: 490,
            internal: true,
            audio: "champagne.mp3",
            annotation: "Let's look at some of the more memorable lines from the series. In fact this is the very first line, talk about setting the tone for the series:",
            line: "So unhappy. I wonder if anyone has ever been this unhappy while drinking champagne?",
        },
        {
            series: "5",
            index: 30,
            internal: false,
            audio: "shit.mp3",
            annotation: "Jez manages to escape the boring play, presumably to go home and watch Heat on DVD, and generously donates his ticket so somebody else can share his pain:",
            line: "Here you go mate. Go and see the second half. It's shit.",
        },
        {
            series: "5",
            index: 587,
            internal: true,
            audio: "nazi.mp3",
            annotation: "As usual, Mark ends up with the bad side of the bargain compared to Jez after their double date:",
            line: "Great, it's me protecting civilisation again while Jeremy has sex. If this was the war, I'd be getting shot by Rommel while he was in Paris getting a blowjob from a Nazi.",
        },
        {
            series: "5",
            index: 636,
            internal: true,
            audio: "spin.mp3",
            annotation: "Mark loses the first battle of the spin war with Sophie:",
            line: "OK, grab your nuts Corrigan, first contact. There she is, Sophie. Should I go over, forget the spin war? Apologise? Stab myself with a fork? They only have plastic. Oh crying, yes nice. That's going to play very well with the floating voters. Nice tears, Goebbels. Her and her mates will probably start handing out vicious cartoons of me as a rodent in a big top hat and everyone will think it's hilarious until a mob comes round and smashes my shop window. At least I've got off the roast wagon. Oh God, there she goes. This is a public relations nightmare. Where do I sit? This must be what it's like being a nonce in prison.",
        },
        {
            series: "5",
            index: 685,
            internal: true,
            audio: "pants.mp3",
            annotation: "Mark has the last laugh... sort of:",
            line: "Oh yeah, they can laugh, but I win because they think I pissed myself. They've no clue I came all in my pants.",
        },
        {
            series: "5",
            index: 144,
            internal: true,
            audio: "vaginas.mp3",
            annotation: "Here we get a glimpse into Jez's pre-gig warm up ritual:",
            line: "I wonder if the A&R guy's here yet. Which one could he be? Could be him, perfect cover. Or her. Or her. Lot of women here. Hmm, women. There they are, walking around. And they've all got them, under their clothes, hiding there, but I know the secret. Vaginas. She's got one, she's got one, she's got one. She's definitely got one. She's trying to make out she hasn't got one but I know she has. Got to stop thinking about vaginas, it's my big night. Mmm, vaginas.",
        },
        {
            series: "5",
            index: 739,
            internal: true,
            audio: "chad.mp3",
            annotation: "Mark objects to the speed dating vote count by comparing it to Florida 2000:",
            line: "Doesn't really work, but she gets the point. I'm just another reject slowly slipping out of the gene pool to get hoovered up by the sex industry. Oh Saz. She implied she might be ticking. Maybe she did tick. Maybe the data wasn't collated correctly. Maybe she's my hanging chad.",
        },
        {
            series: "5",
            index: 180,
            internal: true,
            audio: "elgar.mp3",
            annotation: "Jez struggles to make a \"donation\" at the sperm bank:",
            line: "Hey where's the porn? No porn? Am I supposed to just dry hump myself? There must be something I can use. Would it be wrong? Why not? It's a free country. OK Queeny, it's back in the 50s, you're nice and young, you've just been coronated. I'm taking off your cloak. No, leave the crown on. Oooh, what's this? Stockings? You've been getting through your nylon ration book pretty quickly, you naughty, sexy Queen. Oh shit. Right here we- Oh, Elgar! Oh I've totally lost it now. Thanks a bunch Elgar!",
        },
        {
            series: "5",
            index: 229,
            internal: false,
            audio: "gwen.mp3",
            annotation: "Jez tries to contain his grief after his Great Aunt dies:",
            line: "She is dead, she is dead! Dead old Gwen is dead, dead, dead! Dead, dead, dead, dead, dead, dead, dead! Dead old Gwen is dead!",
        },
        {
            series: "5",
            index: 876,
            internal: false,
            audio: "kebab.mp3",
            annotation: "Mark finally gets to talk shop with a fellow history buff:",
            line: "Well, I did once start a business book, and I've always fancied doing an article about the evacuation of Greece in '41 for the local paper. Not that it would really fit in among all the kebab shop stabbings.",
        },
        {
            series: "5",
            index: 900,
            internal: true,
            audio: "tiramisu.mp3",
            annotation: "Mark has the best night of his life after events finally turn in his favour:",
            line: "Which way will Caesar Corrigan's thumb point? This is a fantastic evening. I've become a military historian, and Jeremy's future happiness rests in my hands. And I've got a tiramisu! This is fucking amazing!",
        },
        {
            series: "5",
            index: 951,
            internal: true,
            audio: "orgasm.mp3",
            annotation: "Mark wakes up in the middle of the night to finally discover that Natalie is not in fact a lesbian:",
            line: "I'm having an orgasm against my will. Oh, God! She's stolen sex off me.",
        },
        {
            series: "5",
            index: 1019,
            internal: true,
            audio: "pensioners.mp3",
            annotation: "Mark does the dirty on Jez and steals Cally from him:",
            line: "Wow, I've got a date. I'm a real piece of shit. I bet those two things go hand in hand. Bet if I got into defrauding pensioners the pussy would really start rolling in.",
        },
        {
            series: "5",
            index: 1149,
            internal: true,
            audio: "sperm.mp3",
            annotation: "After spending the night with Sophie, Mark finds that \"Old Meg\" his trusty condom has perished and frets over the consequences:",
            line: "That is low. That is really low. She's taken my sperm, and sperm is like lending someone less than a fiver. You can't really ask for it back.",
        },
        {
            series: "5",
            index: 1205,
            internal: false,
            audio: "dads.mp3",
            annotation: "The series ends on a cliffhanger when we discover Sophie's child could be Mark's or Jez's:",
            line: "Well, if Sophie continues down her path toward self destruction, we'll end up adopting like a couple of gay dads anyway, so we'll never need to find out whose it is.",
        },
        {
            series: "6",
            index: 547,
            internal: false,
            audio: "grunt.mp3",
            annotation: "Let's zoom in on some of the more memorable lines from the series. The series starts with Mark pulling some strings to get Jez a job at JLB:",
            line: "Hi, Colin, listen, buddy, could you do me a favour and take a punt on a grunt? Yeah, farmyard fodder, a day player. No overheads, no holiday, no contract. Cut and shut, a phone pig. Ha-ha! Exactly, cool, bro, thanks.",
        },
        {
            series: "6",
            index: 641,
            internal: false,
            audio: "skit.mp3",
            annotation: "Mark takes the demise of JLB quite well:",
            line: "Yeah, I'm having a mini wobble on the moustache. What do you think? I just feel, I'm not trying to associate JLB HQ with the Nazis, that would be reductive. I just want to hint at certain similarities in terms of the unquestioning approach both power structures want their underlings to adopt. Do you think people will get that?",
        },
        {
            series: "6",
            index: 697,
            internal: false,
            audio: "shopping.mp3",
            annotation: "Mark reviews Elena's shopping and he doesn't like what he sees:",
            line: "Right. Yeah, she is attractive. Although, brown rice and Pop-Tarts, chamomile tea and economy vodka. That's a car crash of a shopping basket.",
        },
        {
            series: "6",
            index: 717,
            internal: true,
            audio: "boiler.mp3",
            annotation: "Mark wonders if spending money on a new boiler was really worth it:",
            line: "A new boiler. Surely the least enjoyable way to spend a thousand pounds. At least throwing the money out the window you'd see the scrabbling mass, the hate filled faces. I have spent a cool grand on acquiring the resumption of an equitable temperature.",
        },
        {
            series: "6",
            index: 151,
            internal: false,
            audio: "bush.mp3",
            annotation: "Jez should really write more poetry:",
            line: "\"Fuck you, Bush. Fuck you, Bush! It's time to get out of Iraq, Bush. What were you even doing there in the first place, Bush? You didn't even get properly elected, Bush. Are you happy now, Bush? Fuck you, Bush!\"",
        },
        {
            series: "6",
            index: 821,
            internal: false,
            audio: "hot.mp3",
            annotation: "Mark has just found out that he is in fact the father of Sophie's baby after Jez comes clean after originally telling him that he wasn't to impress Elena. But as a consolation he at least wins the battle of the boiler:",
            line: "Yes! Did you hear that Jeremy! Sophie says it's too hot in here! So I was right. I win! Shove that up your bollocks!",
        },
        {
            series: "6",
            index: 869,
            internal: true,
            audio: "ripper.mp3",
            annotation: "Dobby's Jack The Ripper knowledge ticks a box for Mark:",
            line: "I love that she knows it was 1888. So few women these days are Ripper-literate.",
        },
        {
            series: "6",
            index: 872,
            internal: false,
            audio: "helix.mp3",
            annotation: "Mark bemoans the modern state of the world and its addiction to fun:",
            line: "Why does everything have to be fun to be worthwhile? \"Crick and Watson have discovered the double helix\". \"Did they do it on a skateboard? No? Well, fuck off then, I'm not interested.\"",
        },
        {
            series: "6",
            index: 956,
            internal: true,
            audio: "sniper.mp3",
            annotation: "After Jez lectures Mark about love, Mark wonders if he should deliver the truth bomb about Elena:",
            line: "Could wipe that patronising smile off his face with the truth. No, would be like picking off innocent bystanders with a sniper rifle. Fun at first but it'd quickly become a depressing chore.",
        },
        {
            series: "6",
            index: 978,
            internal: true,
            audio: "slang.mp3",
            annotation: "Mark ponders the lack of slang among the middle classes:",
            line: "Builder's tea, I suppose that's middle class slang. We don't coin much slang in the middle classes. \"Pants\", \"'mare\". \"Ooh, I'm having a 'mare. This builder's tea came out pants.\"",
        },
        {
            series: "6",
            index: 309,
            internal: false,
            audio: "plate.mp3",
            annotation: "Jez tries to reconcile the fact that he's the third party in a same-sex relationship:",
            line: "Well, a bit. But basically, not really. I mean, me and this Gail, we're just eating from different sides of the plate. I play woodwind, she's on brass.",
        },
        {
            series: "6",
            index: 368,
            internal: false,
            audio: "party.mp3",
            annotation: "Jez invites Elena to the party:",
            line: "Oh, hi Elena. Yeah, Jez here. Just to say, you know, me and Mark are partying hard this Saturday. I've invited everyone else and then I thought of you. So, uh, there's gonna be some cats from the music biz. Uh, a few cats from film and new media. You know, a whole crowd of cool cats and crazy chicks. Chicks with dicks, chicks without dicks. Guys with dicks. Maybe see you up here, maybe not. Bye-bye. Bye bye-bye bye.",
        },
        {
            series: "6",
            index: 1150,
            internal: false,
            audio: "petty.mp3",
            annotation: "Jez wonders why Mark invited Gerrard to the party:",
            line: "I thought it'd look petty and vindictive not to. And as a petty and vindictive individual I have to take extra care to not appear petty or vindictive.",
        },
        {
            series: "6",
            index: 1188,
            internal: false,
            audio: "crashers.mp3",
            annotation: "Mark ousts the party crashers:",
            line: "Excuse me everyone. I'd like to make an announcement. These two gentlemen are party crashers so I'd be very grateful if none of you spoke to them for the rest of the evening. There is an exclusion zone around them. A cordon sanitaire. Thank you.",
        },
        {
            series: "6",
            index: 1280,
            internal: true,
            audio: "ringtone.mp3",
            annotation: "Mark's first impression of his driving instructor isn't good:",
            line: "Ugh, I'm doing something I hate for someone who doesn't like me, in order to drive around somebody who, as yet, doesn't even exist. Great, I was hoping for a David Attenborough-type instructor. He's more of your chain-wanking, ringtone fanatic.",
        },
        {
            series: "6",
            index: 1286,
            internal: false,
            audio: "drive.mp3",
            annotation: "The first impression proves fairly prescient as Mark struggles with the instructors lax approach to teaching:",
            line: "Look, I'm sorry, but I can't drive. Maybe in your career as a driving instructor you may get one or two pupils from failed states like Eritrea where they have no licensing infrastructure, but basically already know how to drive. However I feel I should warn you that the vast majority are gonna be people like me, who can't drive.",
        },
        {
            series: "6",
            index: 1290,
            internal: true,
            audio: "chips.mp3",
            annotation: "Unsurpisingly, Mark quits his driving lessons and retreats to a cafe for some Shakespeare and chips:",
            line: "This is the life. Bit of Shake-y, enormous plate of chips. And when Sophie goes into labour, we'll call a minicab. What's the big deal? This is a much more productive way of spending four hours than breathing in my instructor's second-hand Superking smoke. I could write a play in the time I'll save. Yeah, what's my play gonna be about? A bloke, a genius, unrecognized in his own time. Mark... Borrigan? And he loves, or maybe even hates, chips.",
        },
        {
            series: "6",
            index: 1326,
            internal: false,
            audio: "evil.mp3",
            annotation: "Mark comforts Jez after he thinks he might have pushed Gail into the lake on purpose:",
            line: "No, Jez, the absolute worst thing anyone could say about you is that you are a selfish, moral blank, whose lazy cynicism and sneering, ironic take on the world encapsulates everything wrong with a generation. But you, my friend, are not evil.",
        },
        {
            series: "6",
            index: 513,
            internal: false,
            audio: "cushty.mp3",
            annotation: "Mark, eventually, drives Jez to see Elena for his last ever sex window:",
            line: "There, you see? You can do it. Very, very slowly, thirty to forty stalls, one major steering error, bit of me on clutch at the crossroads when the nasty man was beeping, but you can do it. Right, I'm just gonna nip in there, persuade her not to get married, convince her that I'm the guy for her, quick bit of how's-your-father, not murder anyone, back in five, off to the hospital. Cushty.",
        },
        {
            series: "7",
            index: 47,
            internal: false,
            audio: "tubes.mp3",
            annotation: "Let's look into some of the most memorable lines from the series. Here Jez tries to subconciously tell Ben to give up on life from his comatose state whilst reading to him from a lad mag:",
            line: "...the premier Wrangler collection. When has good denim ever been cheap? The answer is never. Look, dude, bit of a weird one, but if you aren't gonna make it through, I mean if you can't, then don't worry, because Zahra's great. And, I'll be waiting, and if you check out, in a friendly way, not like a vulture, to check in. And don't worry, I'm not gonna start waggling on any of your tubes, but, and if you have a problem with anything I've just said then, do give me a sign. No? OK. \"I'm in a swimming pool and my bikini pops off. I'm not bothered, I'll just carry on\", and that's a comment from \"Kayleigh, Islip\". You see a picture of Kayleigh there, and her nice bum.",
        },
        {
            series: "7",
            index: 770,
            internal: true,
            audio: "baby.mp3",
            annotation: "Mark sets out his hopes and dreams for his newly born son as he cuts the umbilical chord:",
            line: "God, I can't get any purchase. Thought it would be like Sarah Ferguson, cutting a ribbon, but it's much more meaty, like sawing a dog's leg in half. Oh, my God, there he is, I've got a baby. Maybe, maybe I might be a good person from now on. That might be a good idea. Yeah, lead a wholesome life and be a decent citizen and make the whole world OK, and yeah, this is a biggie, this is definitely a biggie. Maybe my son can sort climate change. He might figure out cold fusion! Not as one of the main guys, that's unrealistic, but in an administrative capacity.",
        },
        {
            series: "7",
            index: 939,
            internal: false,
            audio: "kenneth.mp3",
            annotation: "If you didn't get the bonus points from above here's the answer:",
            line: "Nine inches. It's a nine-incher. Thought it might spice things up. Trouble is, I find it quite intimidating, as a man. I mean look at it, it's like a leg of lamb. So I've decided to call it \"Kenneth\", to take the curse off.",
        },
        {
            series: "7",
            index: 243,
            internal: true,
            audio: "friday.mp3",
            annotation: "Jez struggles to keep up with Zahra's intellectual pursuits after she asks him to see a Richard Avedon symposium on Friday:",
            line: "Jesus Christ I am so out of my depth. Who's Richard Avedon? What's a symposium? At least I know which day Friday is, that's something to cling on to.",
        },
        {
            series: "7",
            index: 1061,
            internal: false,
            audio: "relax.mp3",
            annotation: "Mark sets out his strategy for dealing with being stuck in the Nether Zone:",
            line: "You can't relax! We've got to fight, worry, speculate, tut, pace, swear!",
        },
        {
            series: "7",
            index: 1182,
            internal: false,
            audio: "turkey.mp3",
            annotation: "Mark reacts quite reasonably to Jez not having purchased a turkey for Christmas dinner:",
            line: "You what? No turkey?! You fucking idiot, Jeremy, you total fucking idiot! That was your job, you fucking moron! You cretin! You're a fuckhead! That's what you are, a fucking shit head!!",
        },
        {
            series: "7",
            index: 492,
            internal: false,
            audio: "potatoes.mp3",
            annotation: "Jez was only joking about the turkey, but he was also in charge of veg and there's a lack of potatoes in the kitchen draw:",
            line: "Are you sure potatoes aren't veg? Aren't they... not earth but like, salt. I mean, tomatoes are fruit, and potatoes are... bread? No, I mean they're wheat-y, they don't go in the drawer in the fridge, so... yeah?",
        },
        {
            series: "7",
            index: 1241,
            internal: true,
            audio: "english.mp3",
            annotation: "Mark gets away with introducing Dobby to his parents:",
            line: "It's fine, luckily we're all English, so no one's going to ask any questions. Thank you, centuries of emotional repression.",
        },
        {
            series: "7",
            index: 1312,
            internal: false,
            audio: "messages.mp3",
            annotation: "Mark tries to win Dobby back via answer phone:",
            line: "Nothing from Dobby since Christmas. I want to call again, but when I leave long messages, I have this nagging sense that I'll end up hearing them played back to me in a court of law.",
        },
        {
            series: "7",
            index: 537,
            internal: false,
            audio: "paxman.mp3",
            annotation: "Jez is up for a biggie on New Year's Eve:",
            line: "Oh, come on man. Shake your booty. Tonight, even Paxman's out, hoovering up lines of crank off Krishnan Guru-Murthy. Tonight's the big one!",
        },
        {
            series: "7",
            index: 1369,
            internal: true,
            audio: "lonely.mp3",
            annotation: "After telling Mark he's moving in with Zahra, Mark begins to worry about loneliness:",
            line: "Can't believe he's actually moving out. I'm going to be an unemployed single mother stuck in the flat, eating Frosties from a salad bowl, until I die from loneliness. And two weeks later they break down the door to find Ian sucking on my cold, dead teats.",
        },
        {
            series: "7",
            index: 604,
            internal: false,
            audio: "osborne.mp3",
            annotation: "Jez gets one too many requests for Canapés and dips at Big Suze's posh New Years' Eve party:",
            line: "Oh, I'm sorry. I'm afraid I've left it all in George Osborne's ball-sack. Tell you what, why don't you nip upstairs, wank him off and dip it in that?",
        },
        {
            series: "7",
            index: 610,
            internal: false,
            audio: "hootenanny.mp3",
            annotation: "Jez refuses to compromise partying with a bit of Jools Holland:",
            line: "No! Not the Hootenanny. Never the Hootenanny. We're better than that. We are going to this party! Come on, Mark. Scrabble. Help me scrabble. It's not long till the bongs!",
        },
        {
            series: "8",
            index: 571,
            internal: true,
            audio: "fritzl.mp3",
            annotation: "Let's look at some of the memorable lines from the series. Here Mark tries to get Dobby to move in with him:",
            line: "So great that Dobby's agreed to move in. Just got to close the deal. Get her into the flat, and keep her locked down like Fritzl. No, not like Fritzl. Like a nice, normal, loving guy who knows where she is at all times. Which at no point would be locked in the cellar.",
        },
        {
            series: "8",
            index: 613,
            internal: false,
            audio: "walcott.mp3",
            annotation: "Mark reveals Jez's get rich quick scheme:",
            line: "Jeremy's planning to sell the headline, \"Three-oh Walcott\" to a tabloid newspaper when Theo Walcott turns thirty, and we've agreed not to argue whether that's a good plan.",
        },
        {
            series: "8",
            index: 664,
            internal: true,
            audio: "tariff.mp3",
            annotation: "Gerrard's death hits Mark hard:",
            line: "Jesus. Life. Spinning past. Every second, every single fleeting moment till we're gone. I'm taking a look at my phone tariff. I've got a very strong feeling I'm being fucked in the arse.",
        },
        {
            series: "8",
            index: 686,
            internal: true,
            audio: "rivals.mp3",
            annotation: "After acing the interview at Baths, Bathrooms and Fittings, Mark gets a bit carried away at Gerrard's funeral:",
            line: "This is a mega funeral. It was a mega interview. Hugh was the only real rival. But look what's happened to Gerrard. This is what I do to rivals. I put my rivals in the ground.",
        },
        {
            series: "8",
            index: 50,
            internal: false,
            audio: "therapy.mp3",
            annotation: "Jez starts his first therapy session:",
            line: "So what do you want me to do? Pull down my pants and fertilise the plants? Oh, you'd love that, wouldn't you? Yeah, then you'd have a real patient on your hands. More mental millions for your high interest account, or ISA, or share portfolio, or to spend on your wife, or your boyfriend, chowing down on an Aberdeen Angus steak from your Volkswagen Passat. That's right, kemosabe, I've got your number. Yeah, doesn't feel very nice when the searchlight is turned on the searchlight operator. Hmm, yeah, pal? How about if I just pulled my knob out, and started wanking? Yeah? Oh, you'd love that wouldn't you? My gonads out, one ball dangling in front of each eye. That's your dream, yeah? Well I'm not going to!",
        },
        {
            series: "8",
            index: 874,
            internal: true,
            audio: "napoleon.mp3",
            annotation: "After a spectacular performance in the band name game, Mark plots his revenge:",
            line: "Round one to you, Simon. Next time we do a quiz, it'll be on Napoleon, and while you might scrape through a few Waterloo questions, when I pin you down on the emperor's domestic reforms, I will fuck you very hard in the mouth.",
        },
        {
            series: "8",
            index: 967,
            internal: true,
            audio: "granada.mp3",
            annotation: "Mark buys a cat to lure Dobby into moving in with him:",
            line: "Yes, and this cat's gonna help me lure Dobby in. Like a classic 70s paedo in a Ford Granada.",
        },
        {
            series: "8",
            index: 1003,
            internal: true,
            audio: "mamba.mp3",
            annotation: "Mark starts his MBA course:",
            line: "The start of my new life. \"Hi there, I'm Mark Corrigan, MA, MBA\". That spells \"mamba\", which is a kind of sexy snake. You'll be gone by next week. Why do the thickos come to these things? I suppose because the thickos have insisted no one's allowed to say you're a thicko any more. That's actually quite a clever move by the thickos."
        },
        {
            series: "8",
            index: 493,
            internal: true,
            audio: "train.mp3",
            annotation: "Jez's plan to come clean to Mark and escape the train so as to not face the music backfires:",
            line: "Before my best friend kills me with a tuna baguette. Oh, my fucking God, this train is running on time. This is unprecedented. Oh, no. Oh, fuck! Oh, back to the scene of the crime to face the music and dance, like some mad musical murderer. How the hell am I gonna play this? Just going to totally fucking ignore it. It never happened.",
        },
        {
            series: "9",
            index: 681,
            internal: true,
            audio: "wolf.mp3",
            annotation: "Let's look at some of the best lines from the series. Mark starts the series with a new job:",
            line: "Finally working at a bank, and banks have turned into phone shops. But it is still a bank. I'm the Wolf of Wall Street. Look out, Boots, I'm going to buy a hundred meal deals and eat them off a prossie in the nude.",
        },
        {
            series: "9",
            index: 704,
            internal: true,
            audio: "viking.mp3",
            annotation: "Mark has finally reached his culture limit thanks to Jerry's William Morris documentaries:",
            line: "Ugh, more William Morris. Wallpaper and workers' rights. God, this is like the Dark Ages. Centuries and centuries with nothing to look forward to except the slim possibility a Viking might break down the door and rape me.",
        },
        {
            series: "9",
            index: 76,
            internal: false,
            audio: "antwerp.mp3",
            annotation: "Jez tries to convince Mark that he'll be better off living with him than Jerry and his evenings of culture:",
            line: "Look, the problem for you is I'm your friend. I know you, Mark. I know you like to pretend that you're this stuffed shirt who reads incredibly boring books about dead people killing each other with bayonets and typhoid, but I know the truth. I've watched Grand Designs with you. That smile when some eco-glass gets delayed on its way from Antwerp and the nice couple gets pushed over budget. That's the real you.",
        },
        {
            series: "9",
            index: 112,
            internal: false,
            audio: "litvinenko.mp3",
            annotation: "Jez's plan to get rid of Jerry takes a turn for the macabre:",
            line: "Not full Litvinenko. Just a little bit of something debilitating in his pasta each night. Grind him down, weaken him, till he's all pathetic and you can just scoop him up like a sick whippet and dump him.",
        },
        {
            series: "9",
            index: 880,
            internal: true,
            audio: "best-man.mp3",
            annotation: "Mark rehearses his best man's speech for Super Hans' wedding but gets somewhat distracted:",
            line: "Mention the seven years working in Richer Sounds in Kew, miss out the Thai jail, onto the bands, drop the first marriage, hit Jeremy and their long friendship, minus all the bad blood and occasional sucking each other off, blah, blah, blah, wrap up with a toast to the bride and groom, Hans, or possibly Simon, and his wife, whose Christian name I've unfortunately forgotten. Shit, I don't really know either of their names. There's Dobby. She doesn't like pasanda and quality TV drama. She likes hitchhiking and terrifying actual drama. We don't fit. Oh, my God, I'm letting go. I've crossed the bridge into adulthood. I'm moving on. I'm going to delete her off my GPS. Weird, it looks like she's right behind me. Fuck, what the-",
        },
        {
            series: "9",
            index: 193,
            internal: false,
            audio: "best-man-speech.mp3",
            annotation: "Jez has to deputise for Mark (see above) and deliver an impromptu best man's speech, what could go wrong?",
            line: "Hans. Super Hans, I've known Hans for many a year now. It's been a long road and now, as you've found Molly, er, and I don't really want to get into this, but I've started it now, but I'm going to bring it round, so don't worry. People said Molly wasn't right for you. That she was a downer. But you know what? If someone loves someone, he just loves them. And if that person is considered to be a downer, or even a yawn-a-thon, who cares? And even if someone loves another man, or, what's in a name? Or gender? Is it possible to love two people at once? Three? Four is surely the limit. But is it? What is love anyway? Is it, er, an act, or a feeling or, who am I to speak? Who are you to listen? Why is a marriage a marriage? But society says it's wrong for two men to love one another even though now it says it says that now it's OK? Is it OK because society says it's OK? What next? Dogs getting married? Could I marry my own son? No. Possibly not? Correct. Or is it? What I'm trying to say is that people should do whatever they want to do, at a temperature that suits them, within limits. Thank you.",
        },
        {
            series: "9",
            index: 222,
            internal: true,
            audio: "burgers.mp3",
            annotation: "Jez ponders the ethics of causing Megan's relationship problems and giving her therapy about it at the same time:",
            line: "I'm creating my own work, I'm living off my own mess. Like when they fed all the cows to the other cows in the 90s and we got, what was it? Super burgers?",
        },
        {
            series: "9",
            index: 285,
            internal: false,
            audio: "paintings.mp3",
            annotation: "Jez tries to get involved with an intellectual discussion and ends up comparing Jesus Christ to Hitler:",
            line: "I'm not knocking the guy. I'm just saying, you know, apart from that, what did he actually achieve? I'm not saying I like him but at least Hitler did some paintings.",
        },
        {
            series: "9",
            index: 1118,
            internal: false,
            audio: "poppadoms.mp3",
            annotation: "Mark takes some Class A drugs to impress April but it doesn't really have any effect:",
            line: "I feel completely normal. But also, a bit like I want to karate-chop my hand through a very high stack of poppadoms.",
        },
        {
            series: "9",
            index: 425,
            internal: false,
            audio: "average.mp3",
            annotation: "Mark tries to prove to Jez that he has above average intelligence, you be the judge:",
            line: "Mark no one does maths these days. We've all got calculators in our pockets, just like all our maths teachers said we wouldn't. Anyway this proves nothing. Probably most people are below average.",
        },
        {
            series: "9",
            index: 529,
            internal: false,
            audio: "forty.mp3",
            annotation: "Jez attempts to justify lying about his age after telling Joe he's turning 39 instead of 40:",
            line: "I don't know. Forty is basically fifty, and fifty is dead. Whereas thirty-nine is like thirty-five. Thirty-five is practically thirty. Thirty is twenty. You know?",
        },
    ];
}
export default SentenceAnnotations;